<template>
  <v-card-text>
    <v-data-iterator :items="reels" :items-per-page="10" :page="1">
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            lg="4"
            md="6"
            sm="12"
          >
            <CardReel
              :item="item"
              :srcImage="loadImage(item.url)"
              @edit="$emit('edit', item)"
              @remove="$emit('remove', item)"
            ></CardReel>
            
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-card-text>
</template>

<script>
import CardReel from "@/components/cards/CardReel.vue";
import { loadAPIImage } from "@/utils/images";
export default {
  components: {
    CardReel,
  },
  props: {
    reels: Array,
  },
  methods: {
    loadImage(src) {
      return loadAPIImage(src);
    },
  },
};
</script>

<style lang="scss" scoped></style>
